// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralDocumentCodeApprvService = {};

CollateralDocumentCodeApprvService.getCollateralDocumentCodeApprvList =
  function (userInput) {
    return lossClient({
      url: "/CollateralDocument/approvalItems?pageSize=1000&pageIndex=0",
      method: "get",
    });
  };

export default CollateralDocumentCodeApprvService;
